module.exports = __webpack_public_path__ + "img/success_icon.5d388d3e.svg";